export const API_URL_PATHS = {
	PROPERTIES_URL_PATH: `${import.meta.env.VITE_API_ENDPOINT}/properties`,
	URLSETS_URL_PATH: '/url-sets',
	SCANS_URL_SUB_PATH: 'scans',
	TENANTS_URL_PATH: '/tenants',
	TENANT_OVERVIEW_URL_PATH: '/tenant-overview',
	SCAN_RESULTS_PATH: '/scan-results',
	USER_URL_PATH: '/user',
	VALIDATORS_URL_PATH: '/validators',
	USER_INVITATIONS_URL_PATH: '/user-invitations',
	TRENDS_PATH: '/trends',
	COMPARE_SCANS_PATH: '/scans/compare',
	PROPERTY_VIEWS_PATH: '/views',
	PRODUCTS_EXPORT_PATH: 'products-export',
	TENANTS_FEATURES: 'features',
	CENTRAL_CONFIG_PATH: '/values/json',
	VALUES_OVERRIDE_PATH: '/values-override'
};

const DELETE_BASE_URL = `${import.meta.env.VITE_API_ENDPOINT}/delete`;

export const INSTRUCTIONS_BASE_URL = `${import.meta.env.VITE_API_ENDPOINT}/instructions`;

export const DELETE_URL_PATHS = {
	MFA: `${DELETE_BASE_URL}/mfa`,
	MSDK: `${DELETE_BASE_URL}/msdk`,
	WFA: `${DELETE_BASE_URL}/wfa`,
	WSDK: `${DELETE_BASE_URL}/wsdk`
};
